import React from 'react';
import FormikTextField from 'components/inputs/FormikTextField';
import {get, set, times} from 'lodash';
import makeStyles from '@mui/styles/makeStyles';
import {Box, Grid} from '@mui/material';
import TextField from '../TextField';
import {useController, useFormContext} from 'react-hook-form';
import {useRegisterLabel} from 'common/context/FormContext';
import {useTranslation} from 'react-i18next';
import {replaceAt} from 'common/stringUtils';
import {SetValueOptions} from 'components/hook-form/helpers';
import {colors} from 'common/colors';

const EMPTY_CHAR = ' ';

const useStyles = makeStyles((theme) => ({
   root: {
      // color: theme.palette.error.main,
   },
   input: {
      display: 'inline-block',
      '& > div': {
         fontSize: '2rem',
         width: '4rem',
         borderRadius: '20%',
      },
      '& input': {
         textAlign: 'center',
      },
   },
}));

type Props = {
   name: string;
   length: number;
   autoFocus?: boolean;
};
export const FormOneTimeCode = ({name, length, autoFocus}: Props) => {
   const classes = useStyles();
   const {t} = useTranslation();

   const refArr = React.useRef<HTMLInputElement[]>([]);

   const {
      field: {onChange, onBlur, value, ref},
      fieldState: {error},
   } = useController({
      name,
      // label: otherProps.label,
      // rules: {
      //    required: required,
      //    validate: validate as Validate<string, any>,
      // },
   });
   useRegisterLabel(name, t('One Time Code'));
   const {setValue, watch} = useFormContext();
   // console.debug('FormOneTimeCode error', error);

   return (
      <>
         <Grid className={classes.root} container spacing={4} wrap="nowrap" justifyContent="center">
            {times(length).map((i) => (
               <Grid item key={`${name}[${i}]`}>
                  <TextField
                     // type="number"
                     size="small"
                     autoFocus={autoFocus && i === 0}
                     inputRef={(el) => (refArr.current[i] = el)}
                     className={classes.input}
                     name={`${name}[${i}]`}
                     value={EMPTY_CHAR === value[i] ? '' : value[i]}
                     onChange={(ev) => {
                        const char = ev.target.value;
                        const newVal = replaceAt(watch(name), i, char || EMPTY_CHAR).substring(
                           0,
                           length
                        );
                        setValue(name, newVal, SetValueOptions);
                        if (char) {
                           const el = refArr.current[(i + 1) % length];
                           el.focus();
                           el.select();
                        }
                     }}
                  />
               </Grid>
            ))}
         </Grid>

         {error && <Box sx={{textAlign: 'center', color: colors.error}}>{error.message}</Box>}
      </>
   );
};
